import { NgModule } from '@angular/core';
import { PulseNpsComponent } from './pulse-nps.component';
import { PulseNpsOverallModule } from '../pulse-nps-overall/pulse-nps-overall.module';
import { PulseNpsTrendModule } from '../pulse-nps-trend/pulse-nps-trend.module';
import { NpsCategoryModule } from '../nps-category/nps-category.module';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AlertModule } from 'ngx-bootstrap/alert';
import { EnpsHelpModule } from '../enps-help/enps-help.module';
import { PulseNpsCountModule } from '../pulse-nps-count/pulse-nps-count.module';
import { PulseNpsBreakdownModule } from '../pulse-nps-breakdown/pulse-nps-breakdown.module';
import { BannerModule } from '@xref/xref-lib';
import { LoaderModule } from '../loader/loader.module';
@NgModule({ declarations: [PulseNpsComponent],
    exports: [PulseNpsComponent], imports: [BrowserModule,
        FormsModule,
        PulseNpsOverallModule,
        PulseNpsTrendModule,
        NpsCategoryModule,
        AlertModule.forRoot(),
        EnpsHelpModule,
        PulseNpsCountModule,
        PulseNpsBreakdownModule,
        BannerModule,
        LoaderModule], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class PulseNpsModule {}
